/* ==========================================================================
   Pawly Supply — product.js
   Variant picker, gallery, sticky add-to-cart, quantity price updates.
   ========================================================================== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (c) => window.Pawly.formatMoney(c);

  class ProductForm {
    constructor(section) {
      this.section = section;
      this.form = $('form[data-product-form]', section);
      if (!this.form) return;
      this.product = JSON.parse($('[data-product-json]', section).textContent);
      this.idInput = $('input[name="id"]', this.form);
      this.qtyInput = $('input[name="quantity"]', this.form);
      this.optionInputs = $$('[data-option-input]', section);
      this.atc = $('[data-atc]', section);
      this.atcLabel = $('.btn__label', this.atc);
      this.priceEl = $('[data-price]', section);
      this.stockEl = $('[data-stock]', section);
      this.variantNameEls = $$('[data-variant-name]', section);
      this.sticky = $('[data-sticky-atc]', section);
      this.stickyPrice = this.sticky && $('[data-sticky-price]', this.sticky);
      this.gallery = new Gallery($('[data-gallery]', section));
      this.strings = window.theme.strings;

      this.optionInputs.forEach((i) => i.addEventListener('change', () => this.onOptionChange()));
      if (this.qtyInput) this.qtyInput.addEventListener('change', () => this.renderPrice());
      this.initSticky();
      this.initDelivery();
      this.onOptionChange(true);
    }

    selectedOptions() {
      const groups = $$('[data-option-group]', this.section);
      return groups.map((g) => {
        const checked = $('input:checked', g);
        if (checked) return checked.value;
        const sel = $('select', g);
        return sel ? sel.value : null;
      });
    }

    currentVariant() {
      const groups = $$('[data-option-group]', this.section);
      // No option pickers (single default variant): use the variant in the form, else the first one
      if (!groups.length) {
        const id = String(this.idInput.value);
        return this.product.variants.find((v) => String(v.id) === id) || this.product.variants[0];
      }
      const opts = this.selectedOptions();
      return this.product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    onOptionChange(initial) {
      const variant = this.currentVariant();
      this.variant = variant;
      this.markAvailability();
      if (!variant) {
        this.setAtc(false, this.strings.unavailable);
        return;
      }
      this.idInput.value = variant.id;
      this.renderPrice();
      this.renderStock();
      this.variantNameEls.forEach((el) => { el.textContent = variant.title; });
      if (variant.available) this.setAtc(true, this.strings.addToCart); else this.setAtc(false, this.strings.soldOut);
      if (variant.featured_media && !initial) this.gallery.show(variant.featured_media.id);
      if (!initial) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      this.section.dispatchEvent(new CustomEvent('variant:change', { detail: variant, bubbles: true }));
    }

    markAvailability() {
      // Grey out option values that are not available given the first option selection
      const opts = this.selectedOptions();
      $$('[data-option-group]', this.section).forEach((group, gi) => {
        $$('label.variant-btn', group).forEach((label) => {
          const input = $('input', label);
          const candidate = opts.slice();
          candidate[gi] = input.value;
          const match = this.product.variants.find((v) => v.options.every((o, i) => i > gi ? true : o === candidate[i]) );
          const anyAvail = this.product.variants.some((v) => v.available && v.options.every((o, i) => i > gi ? true : o === candidate[i]));
          label.classList.toggle('is-unavailable', !anyAvail);
          label.classList.toggle('is-selected', input.checked);
          const priceEl = $('.variant-btn__price', label);
          if (priceEl && match && this.product.options.length === 1) priceEl.textContent = money(match.price);
        });
      });
    }

    renderPrice() {
      const v = this.variant; if (!v || !this.priceEl) return;
      const qty = Math.max(1, parseInt(this.qtyInput ? this.qtyInput.value : '1', 10) || 1);
      const price = v.price * qty, compare = (v.compare_at_price || 0) * qty;
      const onSale = compare > price;
      const pct = onSale ? Math.round((1 - price / compare) * 100) : 0;
      this.priceEl.innerHTML =
        '<span class="price__' + (onSale ? 'sale' : 'regular') + '">' + money(price) + '</span>' +
        (onSale ? '<span class="price__compare">' + money(compare) + '</span><span class="price__save">Save ' + pct + '%</span>' : '');
      $$('[data-save-badge]', this.section).forEach((b) => { b.textContent = 'Save ' + pct + '%'; b.classList.toggle('hidden', !onSale); });
      if (this.stickyPrice) this.stickyPrice.textContent = money(price);
      if (this.atcLabel && v.available) this.atcLabel.textContent = this.strings.addToCart + ' — ' + money(price);
    }

    renderStock() {
      if (!this.stockEl) return;
      const v = this.variant;
      const tpl = this.stockEl.dataset;
      this.stockEl.classList.remove('buy__stock--low', 'buy__stock--out');
      if (!v.available) { this.stockEl.textContent = tpl.out; this.stockEl.classList.add('buy__stock--out'); return; }
      if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= parseInt(tpl.lowThreshold || '5', 10)) {
        this.stockEl.textContent = tpl.low.replace('[count]', v.inventory_quantity); this.stockEl.classList.add('buy__stock--low'); return;
      }
      this.stockEl.textContent = tpl.in;
    }

    setAtc(enabled, label) {
      if (!this.atc) return;
      this.atc.disabled = !enabled;
      if (this.atcLabel) this.atcLabel.textContent = label;
      $$('[data-sticky-atc] .btn', this.section).forEach((b) => { b.disabled = !enabled; b.textContent = label; });
      if (enabled) this.renderPrice();
    }

    initDelivery() {
      const el = $('[data-delivery]', this.section); if (!el) return;
      const cutoff = parseInt(el.dataset.cutoff || '14', 10);
      const min = parseInt(el.dataset.min || '3', 10), max = parseInt(el.dataset.max || '7', 10);
      const range = $('[data-delivery-range]', el), cd = $('[data-delivery-countdown]', el);
      const weekend = (d) => d.getDay() === 0 || d.getDay() === 6;
      // Calendar days counted from the order date, so the slowest date is never more than `max` days away.
      const addDays = (d, n) => { const r = new Date(d); r.setDate(r.getDate() + n); return r; };
      const fmt = (d) => d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      const tick = () => {
        const now = new Date();
        const today = !weekend(now) && now.getHours() < cutoff;
        const a = addDays(now, min), b = addDays(now, max);
        if (range) range.textContent = fmt(a) + ' – ' + fmt(b);
        if (cd) {
          if (today) {
            const end = new Date(now); end.setHours(cutoff, 0, 0, 0);
            const mins = Math.max(1, Math.round((end - now) / 60000));
            const t = mins >= 60 ? Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm' : mins + 'm';
            cd.textContent = (this.strings.dispatchCountdown || 'Order within [time] to ship today').replace('[time]', t);
            cd.hidden = false;
          } else cd.hidden = true;
        }
        el.hidden = false;
      };
      tick(); setInterval(tick, 60000);
    }

    initSticky() {
      if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
      const obs = new IntersectionObserver(([e]) => { this.sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 });
      obs.observe(this.atc);
      $('.btn', this.sticky).addEventListener('click', () => this.form.requestSubmit());
    }
  }

  class Gallery {
    constructor(el) {
      this.el = el; if (!el) return;
      this.main = $('[data-gallery-main]', el);
      this.slides = $$('[data-media-id]', this.main);
      this.thumbs = $$('[data-thumb]', el);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(t.dataset.thumb)));
      const zoom = $('[data-zoom]', el);
      if (zoom) zoom.addEventListener('click', () => { const z = this.main.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed', z); });
      // Swipe on mobile
      let x0 = null;
      this.main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      this.main.addEventListener('touchend', (e) => {
        if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        const i = this.slides.findIndex((s) => s.classList.contains('is-active'));
        const next = this.slides[(i + (dx < 0 ? 1 : -1) + this.slides.length) % this.slides.length];
        if (next) this.show(next.dataset.mediaId);
      }, { passive: true });
    }
    show(id) {
      if (!this.el) return;
      id = String(id);
      this.slides.forEach((s) => {
        const on = s.dataset.mediaId === id;
        s.classList.toggle('is-active', on);
        const v = s.querySelector('video'); if (v && !on) v.pause();
      });
      this.thumbs.forEach((t) => t.setAttribute('aria-pressed', t.dataset.thumb === id));
      this.main.classList.remove('is-zoomed');
      const zoom = $('[data-zoom]', this.el); if (zoom) zoom.setAttribute('aria-pressed', 'false');
    }
  }

  function boot() { $$('[data-product-section]').forEach((s) => { if (!s.__pf) s.__pf = new ProductForm(s); }); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
